import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "email",
  "use": "email-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"email\"><path d=\"M29 6H3a1 1 0 00-1 1v18a1 1 0 001 1h26a1 1 0 001-1V7a1 1 0 00-1-1zm-1 16.54l-7.15-7.33L28 9.16zm-12-3.23l3.32-2.81 7.31 7.5H5.56l7.64-7.06zM26.27 8L16 16.69 5.73 8zm-14.61 7.64L4 22.72V9.16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/email.svg
// module id = XGTl
// module chunks = 39 44